/* eslint-disable import/prefer-default-export */
import { useState } from "react";
import { fetchAttachmentSignedUrl } from "../../apicalls/notificationFunctions";
import { getAttachmentDisplayName } from "../../utils/string-utils";
import { downloadFileFromSignedUrl } from "../../utils/download-utils";

export function useNotificationDownload() {
  const [downloadError, setDownloadError] = useState<string | null>(null);
  const [loadingKeys, setLoadingKeys] = useState<Set<string>>(new Set());

  const handleDownload = async (key: string) => {
    setDownloadError(null);
    setLoadingKeys((prev) => new Set(prev).add(key));

    try {
      const signedUrl = await fetchAttachmentSignedUrl(key);
      const err = await downloadFileFromSignedUrl(
        signedUrl,
        getAttachmentDisplayName(key),
      );
      if (err) {
        // eslint-disable-next-line no-console
        console.error("useNotificationDownload.handleDownload:", err);
        setDownloadError("NOTIFICATIONS.DOWNLOAD_ERROR");
      }
    } catch (err: unknown) {
      // eslint-disable-next-line no-console
      console.error("useNotificationDownload.handleDownload:", err);
      setDownloadError("NOTIFICATIONS.DOWNLOAD_ERROR");
    } finally {
      setLoadingKeys((prev) => {
        const next = new Set(prev);
        next.delete(key);
        return next;
      });
    }
  };

  const isLoadingKey = (key: string) => loadingKeys.has(key);

  return { handleDownload, isLoadingKey, downloadError };
}
